module.exports = __webpack_public_path__ + "static/media/bowtie-loader.95195998.gif";